import React from 'react';
import { Box, Typography } from '@p81-common/ui';
import { RuleViolation } from '../../../helpers/types';
import { createRuleViolationListClasses } from './styles';

interface RuleViolationListProps {
  violations: RuleViolation[];
}

// MAPI's `message` is shown verbatim - it is already specific ("has a cancelled
// subscription", "must accept the MSSP PAYG terms in the partner portal") and
// the audience is internal, so translating per rule would only add drift.
// The `rule` is shown alongside it because it is the same value as Datadog's
// `@errorRule` facet, which is how an operator correlates the two.
const RuleViolationList = ({ violations }: RuleViolationListProps) => {
  const classes = createRuleViolationListClasses();

  return (
    <Box component="ul" className={classes.list}>
      {/* Index-suffixed: a tenant can carry the same violation twice, and a
          duplicate key warns and reconciles unstably. */}
      {violations.map(({ rule, message }, index) => (
        <Box
          component="li"
          key={`${index}:${rule}:${message}`}
          className={classes.item}
        >
          <Typography variant="body2" className={classes.message}>
            {message}
          </Typography>
          {rule && (
            <Typography variant="caption" className={classes.rule}>
              {rule}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default RuleViolationList;
